export const enum AppstoreAppsFormEnum {
    brandApps = 'brandApps',
}

export const enum AppstoreAppsBrandItemEnum {
    brandId = 'brandId',
    apps = 'apps',
}

type AppstoreAppsBrandItemType = {
    [AppstoreAppsBrandItemEnum.brandId]?: number;
    [AppstoreAppsBrandItemEnum.apps]: Array<string>;
};

export type AppstoreAppsFormType = {
    [AppstoreAppsFormEnum.brandApps]: Array<AppstoreAppsBrandItemType>;
};
